if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // Check for upsell checkboxes
        const upsellCheckboxes = document.querySelectorAll('input[type="checkbox"].upsell-checkbox:checked');
        const upsellVariantIds = Array.from(upsellCheckboxes).map(checkbox => checkbox.dataset.variantId).filter(id => id);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // Function to add a single item to cart
        const addToCart = (variantId, quantity = 1) => {
          const itemFormData = new FormData();
          itemFormData.append('id', variantId);
          itemFormData.append('quantity', quantity);
          
          if (this.cart) {
            itemFormData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            itemFormData.append('sections_url', window.location.pathname);
          }

          const itemConfig = { ...config };
          itemConfig.body = itemFormData;

          return fetch(`${routes.cart_add_url}`, itemConfig)
            .then((response) => response.json());
        };

        // Add all items sequentially (main product + upsells)
        const allVariantIds = [formData.get('id'), ...upsellVariantIds];
        const allQuantities = [formData.get('quantity') || 1, ...upsellVariantIds.map(() => 1)];
        
        console.log('Adding variants to cart:', allVariantIds);

        // Add items one by one sequentially to ensure all are added
        let addPromise = Promise.resolve();
        let finalResponse = null;

        allVariantIds.forEach((variantId, index) => {
          addPromise = addPromise.then(() => {
            return addToCart(variantId, allQuantities[index])
              .then((response) => {
                // console.log(`Added variant ${variantId}:`, response);
                let error_message = response.errors || response.description

                if (error_message == "Required parameter missing or invalid: id") {
                  error_message = "You need to choose atleast 1 variant!"
                }

                console.log('error_message', error_message)
                
                // Handle error for main product (first item)
                if (index === 0 && response.status) {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: variantId,
                    errors: error_message,
                    message: response.message,
                  });

                  this.handleErrorMessage(error_message);

                  const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                  if (!soldOutMessage) return;
                  this.submitButton.setAttribute('aria-disabled', true);
                  this.submitButtonText.classList.add('hidden');
                  soldOutMessage.classList.remove('hidden');
                  this.error = true;
                  throw new Error('Main product failed to add');
                }
                
                // Store the last successful response (this will have the most up-to-date cart data)
                if (!response.status) {
                  finalResponse = response;
                }
                
                return response;
              })
              .catch((error) => {
                if (index === 0) {
                  // Re-throw error for main product
                  throw error;
                } else {
                  // Log error for upsell items but continue
                  console.error(`Failed to add upsell item ${variantId}:`, error);
                  return null;
                }
              });
          });
        });

        addPromise
          .then((response) => {
            if (!finalResponse || this.error) return;

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: finalResponse, // Use the final response with updated cart data
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(finalResponse);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(finalResponse);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = false, text) {
        if (disable) {
          
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}